import {Badge} from '@sanity/ui'

export function AssistFeatureBadge() {
  return (
    <Badge fontSize={0} style={{margin: '-2px 0'}} tone="primary">
      Beta
    </Badge>
  )
}
